import {ICanonicalMapper} from '../../Firestore/ICanonicalMapper'
import {IOrderEntry, OrderEntry} from './OrderEntry'
import moment from "moment";

export class OrderEntryMapper implements ICanonicalMapper {
  public map(data: IOrderEntry): OrderEntry {
    const entry = new OrderEntry(data.upc, data.description)

    entry.id = data.id
    entry.priceListEntryId = data.priceListEntryId
    entry.vendorCompanyId = data.vendorCompanyId
    entry.priceListId = data.priceListId
    entry.quantity = parseInt(String(data.quantity || '0'), 10)
    entry.receivedQuantity = data.receivedQuantity ? parseInt(data.receivedQuantity.toString(), 10) : undefined
    entry.additionalQuantity = data.additionalQuantity ? parseInt(data.additionalQuantity.toString(), 10) : undefined
    entry.pricePerUnit = data.pricePerUnit ? parseFloat(data.pricePerUnit.toString()) : undefined
    entry.status = data.status
    entry.dateAccepted = data.dateAccepted ? moment(data.dateAccepted).toDate() : undefined
    entry.shippingDate = data.shippingDate ? moment(data.shippingDate).toDate() : undefined
    entry.image = data.image
    entry.receivingNotes = data.receivingNotes
    entry.orderingNotes = data.orderingNotes
    entry.category = data.category
    entry.quantityType = data.quantityType
    entry.receivedQuantityType = data.receivedQuantityType
    entry.originalEntryId = data.originalEntryId

    return entry
  }
}
